import accountsTableTemplate from '../../../tables/accounts/reactAccountsTable.html';
import { AccountService } from '../../../../services/AccountService';
import {groups, accounts, USER_ACC} from '../../../../services/arsweb/RoutingPaths';
import { DETAIL_ACCOUNTROUTE } from '../../../../views/accounts/AccountController';
import { ACCOUNTS_TITLE } from '../../../../services/arsweb/TableTitles';
import {ReactTableController} from "../../reactTableController";
import {reactAccountCols, defaultSortModel} from "../../accounts/accountColDefs";

export const ACCOUNTGROUPS_TAB = "accountGroups";

/** @ngInject */
export function groupAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            hideColumns: '=',
            parentController: '='
        },
        templateUrl: accountsTableTemplate,
        controller: AccountGroupsTableController,
        controllerAs: 'accountsTableController'
    };
}

/** @ngInject */
export class AccountGroupsTableController extends ReactTableController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, DETAIL_ACCOUNTROUTE, new AccountService(userService),
        `${groups}/${$scope.parentController.id}/${accounts}`, ACCOUNTS_TITLE, 'accountGroupsTableParams',
            "accountName", false, [], defaultSortModel);
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {

        userService.promise.then(()=> {

            // react account columns
            this.colDefs = reactAccountCols(this.translate, userService,[]);
            this.initCols();
            // react gridParameters for account table
            const accountGridParams = {
                suppressRowSelection: true,
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency', "countryName": "country"},
                url: this.backendService.service.getServiceUrl(`${USER_ACC}${groups}/${this.$scope.parentController.id}${accounts}`)};
            delete this.defaultReactGridParams.onSearchInputChange;
            delete this.defaultReactGridParams.onReport;
            delete this.defaultReactGridParams.onExport;

            const gridProperties = {...this.defaultReactGridParams, ...accountGridParams};
            if(this.$scope.parentController.reactTabs) {
                // init the gridProperties for the tab
                this.tab = this.$scope.parentController.reactTabs.tabs
                    .filter(tab => tab.value === ACCOUNTGROUPS_TAB)[0];
                this.tab.gridProperties = gridProperties;
            } else {
                this.reactGridParams = gridProperties
            }
        });
    }
}
